// src/Components/EmailVerificationRedirector.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';

const EmailVerificationRedirector = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAndRedirect = async () => {
      const user = auth.currentUser;
      const alreadyRedirected = localStorage.getItem('emailVerifiedRedirected');

      // If user is logged in and not already redirected
      if (user && !alreadyRedirected) {
        await user.reload(); // Refresh user info

        if (user.emailVerified) {
          // Set flag to avoid future redirects
          localStorage.setItem('emailVerifiedRedirected', 'true');
          // Redirect to homepage
          navigate('/');
        }
      }
    };

    checkAndRedirect();
  }, [navigate]);

  return null;
};

export default EmailVerificationRedirector;
